var timeout = false;
var rtime;
var delta = 200;

var productOptions = {
	init : function(){
		if($('.product-details .tab-general .option-filter').length===0){
			$('.product-details .tab-general .side-panel .product-options .compare-prices .btn.disabled').removeClass('disabled');
		}
		$('.product-details .tab-general .option-filter select').change(function(){
			var empty = false;
			if($(this).val()==''){
				$('.product-details .tab-general .side-panel .product-options .compare-prices .btn').addClass('disabled');
			}else{
				$('.product-details .tab-general .option-filter select').each(function(){
					if($(this).val()==''){
						empty = true;	
					}
				});

				if(!empty){
					$('.product-details .tab-general .side-panel .product-options .compare-prices .btn.disabled').removeClass('disabled');
				}
			}			
		});
		$('.product-details .tab-general .side-panel .product-options .compare-prices .btn').click(function(){
			setTimeout(function(){
				if($('.product-pricing').hasClass('in')){
					$('.compare_price_alert').fadeOut(300);	
				}else{
					$('.compare_price_alert').fadeIn(300);
				}	
			},500);			
		});
		$('.product-details .product-pricing .btn-close	').click(function(){
			$('.compare_price_alert').fadeIn(300);
		});
		
	}	
};


$(window).resize(function(){
	equalizeHeight('.product-details .tab-general .eq-block');
});


var productsList = {
    init : function(id){

    	
    	var width_latest = $(window).width(); 
    	
 
    	var target = id+' .eq-height .item .product_info .product_info-name';

    	if (width_latest > 1200) {
    		 var min_height = 0;
	    	 $('.col-item-small').each(function(){
	            if($(this).innerHeight() > min_height){
	                min_height = $(this).innerHeight();
	            }
	        });
	    	 $('.item-large').css('height',min_height);
        }

    	if (width_latest < 1201) {
	      target = id+' .eq-height .product_info .product_info-name';
        }
    	 if (width_latest > 575) {
	        equalizeHeight(target);		
        }
       
    	 $(window).resize(function(){
        	if ($(window).width()==width_latest && $(window).width() < 576 ) return; 
    		width_latest = $(window).width();
			var rtime = new Date();
			if (timeout === false) {
				timeout = true;
				resizedeltaFunction(target);
			}
		});

    	 var $isotopeGrid = $('.isotope-product-grid');
 		
		var grid_pckry = $isotopeGrid.packery({		    	
            itemSelector: '.col-item', 
            percentPosition:true,
            transitionDuration:0
        });



    	setTimeout(function(){ $('.isotope-product-grid').packery();  Waypoint.refreshAll(); }, 500);

    	setTimeout(function(){ productsList.afterInit();  }, 1000);


		if( $('.fixed-filters').length>0){
			var lastScrollTop = 0;
			$(window).scroll(function () {
				"use strict";
				if ($(window).scrollTop() > 180) {
			        $('.fixed-filters').show();
			    }
			    else {
			        $('.fixed-filters').hide();
			    }
				 /*var st = $(window).scrollTop();

				  if (st > lastScrollTop || st === 0){
				      $('.fixed-filters').slideUp();
				   } else {
				      $('.fixed-filters').slideDown();
				   }
				   lastScrollTop = st; */
			});
		}
		
    },
    afterInit :function(){
    	 
		if($('#view-more').length>0){
	    	var waypoint = new Waypoint({
	     	  element: $('#view-more'),
	          handler: function(direction) {
	          	
          		if($('#view-more').length>0 && $('#view-more').offset().top > Waypoint.viewportHeight() ){
          		 	$('#view-more').trigger('click');     
				}      
	          },
	          offset: 'bottom-in-view'
	        });

			
	    }
	   
 
    },
    categoryNav: function(target){ 
    	var category_id = $(target).data('category_id');
    	var url = $(target).data('url');
    	var title = $(target).data('title');
    	
    	$('category-item').removeClass('active');
    	$(target).addClass('active');

    	var p = $(target).closest('.partial');
    	p.removeAttr( "data-subcategory_id" );
    	var s = $('.next-draw');
    	p.find('.widget-content').html('');
	 	 Waypoint.refreshAll();
		changeUrl(title,url);
		if(p.find('.top-filters .category select[name="category"]').length>0){
			p.find('.top-filters .category select[name="category"]').data('category_parent',category_id);
		}
        p.data('page',0);
      
      
        p.data('category_id',category_id);
        p.addClass('loading');
        if(s.length > 0){
        	scroll2element(s.get());	
        }else{
        	scroll2element($(target).closest('.partial').get());
        }
        load_partial(p);
        return false;

    },
}


var inlineProducts = {
    init : function(id){
        var width_latest = $(window).width(); 
    	var target = id+' .eq-height  .product_info .product_info-name';
       	
		$slider = $( id+ ' .products-grid');
     	
     	$slider.on('initialized.owl.carousel', function(event) {  equalizeHeight(target);  });
        $slider.owlCarousel({
        	  responsiveClass:true,
              nav:false,
              
        	  lazyLoad: true,
        	  margin:30,
        	  responsive:{
			        0:{
			            items:1,
			            margin: 15,
			            loop: ($( id+ ' .products-grid .inline-item').length > 1) ?true:false,
			            pullDrag: ($( id+ ' .products-grid .inline-item').length > 1) ?true:false,
			        	mouseDrag: ($( id+ ' .products-grid .inline-item').length > 1) ?true:false,
			        	touchDrag: ($( id+ ' .products-grid .inline-item').length > 1) ?true:false,
			        },
			         
			        576:{
			            items:2,
			            margin: 15,
			            loop: ($( id+ ' .products-grid .inline-item').length > 2) ?true:false,
			            pullDrag: ($( id+ ' .products-grid .inline-item').length > 2) ?true:false,
    	  				mouseDrag: ($( id+ ' .products-grid .inline-item').length > 2) ?true:false,
        	  			touchDrag: ($( id+ ' .products-grid .inline-item').length > 2) ?true:false,
			        },

			        992:{
			            items:3,
			            loop: ($( id+ ' .products-grid .inline-item').length > 3) ?true:false,
			            pullDrag: ($( id+ ' .products-grid .inline-item').length > 3) ?true:false,
    	  				mouseDrag: ($( id+ ' .products-grid .inline-item').length > 3) ?true:false,
        	  			touchDrag: ($( id+ ' .products-grid .inline-item').length > 3) ?true:false,
			        },

			        1400:{
			            items:4,
			            loop: ($( id+ ' .products-grid .inline-item').length > 4) ?true:false,
			        	pullDrag: ($( id+ ' .products-grid .inline-item').length > 4) ?true:false,
			        	mouseDrag: ($( id+ ' .products-grid .inline-item').length > 4) ?true:false,
			        	touchDrag: ($( id+ ' .products-grid .inline-item').length > 4) ?true:false,
			        }
			    }
        });

      


        $(window).resize(function(){
        	if ($(window).width()==width_latest) return; 
    		width_latest = $(window).width();
			var rtime = new Date();
			if (timeout === false) {
				timeout = true;
				resizedeltaFunction(target);
				
			}
		});
    }
}


function resizedeltaFunction(target){	
	if (new Date() - rtime < delta) {
        setTimeout(resizedeltaFunction, delta);
    } else {
        timeout = false;		
		equalizeHeight(target);
    }	
}

function equalizeHeight(target,offset) {
	$(target).each(function(){
		$(target).css('min-height','auto');
	});	
    var min_height = 0;
    setTimeout(function(){
        $(target).each(function(){
            if($(this).innerHeight() > min_height){
                min_height = $(this).innerHeight();
            }
        });
        if(min_height>0){
            $(target).css('min-height',min_height);
        }
		$(target).each(function(){			 
			$(target).removeClass('autoHeight');
			
			if($(this).hasClass('banner-item-tall')){
				$(this).css('min-height',$(target).innerHeight()-13);
			}
		});
    },500);	
   
}


$(document).on("click",".toggle-quantity",function() {
   		$(this).toggleClass('d-none');

   		if($(this).parent().parent().parent().find('.add-to-cart-btn').hasClass('d-none')){
   			$(this).parent().parent().parent().find('.add-to-cart-btn').removeClass('d-none');
   		}
		$(this).closest('.add-coupons-to-cart').find('.add-to-cart-item,.quantity-details-input').toggleClass('d-none');	
		return false;	
	});
	
	$(document).on("click",".quantity-right-plus",function(e) {
		 e.preventDefault();

		 var target_input = $(this).parent().parent().find('input[name="quantity"]');
         var quantity = parseInt(target_input.val());
          target_input.val(quantity + 1);
         target_input.trigger('change');
	});


	$(document).on("click",".quantity-left-minus",function(e) {
		
		  e.preventDefault();
		    var target_input = $(this).parent().parent().find('input[name="quantity"]');
            var quantity = parseInt(target_input.val());
            if(quantity>1 ){
            	target_input.val(quantity - 1);
            	target_input.trigger('change');
            }
	});


	$(document).on("change",'input[name="quantity"]',function(e) {
	     var target_input = $(this);
         var quantity = parseInt(target_input.val());
          var max_value = Number(target_input.attr('max')); 
       
		  if(Number(quantity + 1) > max_value){
         	target_input.val(max_value);
         }
	});
		

function saveProduct($this){

	$.ajax({
		type: $this.hasClass('saved') ? "DELETE" : "POST", 
		url: "/users/products/"+$this.data('id'), 
		success:function(data){
			if(data.status === 'ok'){
                if( !$this.hasClass('saved')){
					$('.save-product[data-id="'+$this.data('id')+'"]').addClass('saved');					
				}else{
					$('.save-product[data-id="'+$this.data('id')+'"]').removeClass('saved');
				}
				actionResponseModal(data.message,'success','.actions-block .save');
			}else{
				actionResponseModal(data.message,'error','.actions-block .save');	
			}				
		}
	});
}


var detailsProducts = {
	 init : function(){
	 
        var $isotopeGrid = $('.isotope-grid');
 		$isotopeGrid.imagesLoaded( function() {			
			$isotopeGrid.isotope({		    	
                itemSelector: '.grid-item', 
                layoutMode: 'masonry',
                percentPosition: true,
                masonry: {
                	gutter:'.gutter-sizer'
                }                
            });
		});
		if($('.product-main-content').length){

			jQuery('.product-images-grid, .product-main-content').theiaStickySidebar({
			  // Settings
			  additionalMarginTop: 100
			});
		}
	 }


}

var productsCarousel = {
    init : function(){
       	
		$slider = $( '.product-gallery');
        $slider.owlCarousel({
        	margin:10,
        	center: true,
		    nav:false,
		    loop: true,
		    autoHeight:true,
		    responsive:{
		        0:{
		            items:1
		        },
		        576:{
		            items:1
		        },
		        992:{
		            items:1
		        }
		    }
        });


      
        $('.carousel-controls.btn-prev').click(function() {
		    $( '.product-gallery').trigger('prev.owl.carousel');
		});
		// Go to the previous item
		$('.carousel-controls.btn-next').click(function() {
			$( '.product-gallery').trigger('next.owl.carousel');
		});

        if($('.product-main-content').length){

			jQuery('.product-images-grid, .product-main-content').theiaStickySidebar({
			  // Settings
			  additionalMarginTop: 100
			});
		}
    }
}